import React, { Children, useEffect, useRef, useState } from 'react';
import styled from "styled-components";

const OuterBorder = styled.div`
  position: relative;
  left: ${props => props.offset ? props.offset : "0px"};
  border-left: 2px solid silver
`

const InnerBorder = styled.div`
  position: relative;
  left: ${props => props.offset ? `-${props.offset}` : "0px"};
  padding-bottom: 15px
`

const LastOuterBorder = styled(OuterBorder)`
  border-image: linear-gradient(to bottom, silver 27px, rgba(0,0,0,0) 27px);
  border-image-slice: 1;
`

const OffsetedBorder = ({children, offset}) => {
  return(
    <OuterBorder offset={offset}>
      <InnerBorder offset={offset}>
        {children}
      </InnerBorder>
    </OuterBorder>
  )
}

const LastOffsetedBorder = ({children, offset}) => {
  return(
    <LastOuterBorder offset={offset}>
      <InnerBorder offset={offset}>
        {children}
      </InnerBorder>
    </LastOuterBorder>
  )
}

const SubContainer = styled.div`
  margin-left: 54px;
  position: relative;
  &:before {
    content: "";
    position: absolute;
    top: 25px;
    left: -27px;
    width: 29px;
    height: 2px;
    background-color: grey;
    opacity: .4;
  }
`

const TreeBorderStructure = ({children}) => {
  const nbChildren = children.flatMap((x)=>(x)).length
  const wrappedChildren = Children.map(children, (child, i)=> {
    if(i === 0) {
      return (
        <OffsetedBorder offset="27px">
          {child}
        </OffsetedBorder>
      )
    } else if (i === (nbChildren - 1)) {
      return (<LastOffsetedBorder offset="27px">
        <SubContainer>
          {child}
        </SubContainer>
      </LastOffsetedBorder>)
    } else {
      return (<OffsetedBorder offset="27px">
        <SubContainer>
          {child}
        </SubContainer>
      </OffsetedBorder>)
    }
  })
  return (<>{wrappedChildren}</>)
}

export default TreeBorderStructure;